import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { MessageBusService } from 'src/app/core/services/message-bus.service';
import { PublicProfileService } from 'src/app/core/services/public-profile.service';
import { ClinicHistoryByHashResult } from 'src/app/modules/medical-orders/resolvers/clinic-history-by-hash.resolver';
import { PublicProfileAvatarComponentModel } from 'src/app/shared/components/public-profile-avatar/public-profile-avatar.component';

@Component({
  selector: 'app-professional-license',
  templateUrl: './professional-license.component.html',
  styleUrls: ['./professional-license.component.css']
})
export class ProfessionalLicenseComponent implements OnInit {

  avatarModel: PublicProfileAvatarComponentModel;
  license: any;
  idHistoriaClinica: string;
  professionalLicense: ClinicHistoryByHashResult;
  returnUrl = '';
  

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private messageBusService: MessageBusService,
    private publicProfileService: PublicProfileService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.messageBusService.hideHeader();
    
    this.route.data.subscribe(data => {
      this.professionalLicense = data['professionalLicense'];
  
      this.idHistoriaClinica = this.route.snapshot.paramMap.get('id') || '';
      this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '';
  
      this.avatarModel = new PublicProfileAvatarComponentModel();
      this.avatarModel.avatarUrl = this.professionalLicense.avatarModel.direccionUbicacionFotoMedico;
  
      if (this.professionalLicense.licencia?.jsonIdentificacion) {
        this.license = JSON.parse(this.professionalLicense.licencia.jsonIdentificacion);
      }
    });

  }

  onBackClick(): void {
    const state = this.professionalLicense;

    this.router.navigateByUrl(this.returnUrl, { state });
  }

  goToPublicProfile(): void {
    const publicProfileUrl = this.publicProfileService.getPublicProfileUrl(this.professionalLicense.avatarModel.nombreIdentificacionPerfil);
  
    this.publicProfileService.openPublicProfile(publicProfileUrl);
    setTimeout(() => this.messageBusService.hideHeader(), 700);
  }

  imgError(event: Event) {
    const element = event.target as HTMLImageElement;
    element.style.display = "none";
    event.preventDefault();
  }

}
